import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/product-manage',
    name: 'frame-product-manage',
    component: () => import('../views/ProductManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/product-edit',
    name: 'frame-product-edit',
    component: () => import('../views/ProductEditFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/category-manage',
    name: 'frame-category-manage',
    component: () => import('../views/CategoryManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/store-manage',
    name: 'frame-store-manage',
    component: () => import('../views/StoreManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/doctor-manage',
    name: 'frame-doctor-manage',
    component: () => import('../views/DoctorManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/agreement-manage',
    name: 'frame-agreement-manage',
    component: () => import('../views/AgreementManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/home-config',
    name: 'frame-home-config',
    component: () => import('../views/HomeConfigFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/user-assets',
    name: 'frame-user-assets',
    component: () => import('../views/UserAssetManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/reservation-manage',
    name: 'frame-reservation-manage',
    component: () => import('../views/ReservationManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/free-consult-manage',
    name: 'frame-free-consult-manage',
    component: () => import('../views/ReservationManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/activity-manage',
    name: 'frame-activity-manage',
    component: () => import('../views/ActivityManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/coupon-template-manage',
    name: 'frame-coupon-template-manage',
    component: () => import('../views/CouponTemplateManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/user-coupon-manage',
    name: 'frame-user-coupon-manage',
    component: () => import('../views/UserCouponManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/manual-coupon-grant',
    name: 'frame-manual-coupon-grant',
    component: () => import('../views/ManualCouponGrantFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/coupon-auto-grant-rule-manage',
    name: 'frame-coupon-auto-grant-rule-manage',
    component: () => import('../views/CouponAutoGrantRuleManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/member-level-manage',
    name: 'frame-member-level-manage',
    component: () => import('../views/MemberLevelManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/point-deduction-manage',
    name: 'frame-point-deduction-manage',
    component: () => import('../views/PointDeductionManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/point-reward-rule-manage',
    name: 'frame-point-reward-rule-manage',
    component: () => import('../views/PointRewardRuleManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/invite-reward-rule-manage',
    name: 'frame-invite-reward-rule-manage',
    component: () => import('../views/InviteRewardRuleManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/point-reward-grant-record',
    name: 'frame-point-reward-grant-record',
    component: () => import('../views/PointRewardGrantRecordFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/invite-reward-grant-record',
    name: 'frame-invite-reward-grant-record',
    component: () => import('../views/InviteRewardGrantRecordFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/group-buy-manage',
    name: 'frame-group-buy-manage',
    component: () => import('../views/GroupBuyManageFrame.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/frame/placeholder',
    name: 'frame-placeholder',
    component: () => import('../views/FramePlaceholder.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function getToken() {
  return localStorage.getItem('token') || sessionStorage.getItem('token') || ''
}

router.beforeEach((to, _from, next) => {
  const token = getToken()
  if (to.meta.requiresAuth && !token) {
    next('/login')
    return
  }
  if (to.path === '/login' && token) {
    next('/index')
    return
  }
  next()
})

export default router
